// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"641ea50b","600":"217e4295","850":"104befbb"}[chunkId] + ".chunk.js";
};